import React from 'react';
import './Footer.css';

const Footer = ({ openModal }) => {
  return (
    <footer className="footer">
      <div className="footer-top container">
        <div className="footer-brand">
          <img
            src="https://embracebeautyclinic.com/assets/EmbraceLogowhite.png"
            alt="Embrace Beauty"
            className="footer-logo"
            onError={e => {
              e.target.src = 'https://embracebeautyclinic.com/assets/Embracelogo.png';
            }}
          />
          <p>
            Welcome to Embrace Beauty Aesthetics, where science and beauty unite to help you
            look and feel your best.
          </p>
          <a
            href="https://www.instagram.com/embracebeautyclinic/"
            target="_blank"
            rel="noreferrer"
            className="footer-social"
            aria-label="Instagram"
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="2" y="2" width="20" height="20" rx="5"/>
              <circle cx="12" cy="12" r="4"/>
              <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none"/>
            </svg>
          </a>
        </div>

        <div className="footer-col">
          <h5>Quick Links</h5>
          <ul>
            <li><a href="#about-us">About Us</a></li>
            <li><a href="#our-services">Services</a></li>
            <li><a href="#contact">Contact</a></li>
          </ul>
        </div>

        <div className="footer-col">
          <h5>Useful Links</h5>
          <ul>
            <li><a href="https://embracebeautyclinic.com/privacy-policy.php" target="_blank" rel="noreferrer">Privacy Policy</a></li>
            <li><a href="https://embracebeautyclinic.com/terms-and-onditions.php" target="_blank" rel="noreferrer">Terms and Conditions</a></li>
            <li><a href="https://embracebeautyclinic.com/disclaimer.php" target="_blank" rel="noreferrer">Disclaimer</a></li>
          </ul>
        </div>

        <div className="footer-col">
          <h5>Make Appointment</h5>
          <p className="footer-hours">9 AM - 10 PM, Monday - Saturday</p>
          <div className="footer-socials">
            <a href="https://www.instagram.com/embracebeautyclinic/" target="_blank" rel="noreferrer" className="footer-social-btn" aria-label="Instagram">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <rect x="2" y="2" width="20" height="20" rx="5"/>
                <circle cx="12" cy="12" r="4"/>
                <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none"/>
              </svg>
            </a>
            <a href="#" className="footer-social-btn" aria-label="Facebook">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M24 12.073c0-6.627-5.373-12-12-12S0 5.446 0 12.073C0 17.565 3.656 22.171 8.688 23.5v-8.11H6.07v-3.317h2.617V9.56c0-2.587 1.542-4.017 3.9-4.017 1.13 0 2.31.201 2.31.201v2.537h-1.3c-1.281 0-1.682.796-1.682 1.613v1.942h2.862l-.457 3.317H11.9V23.5C16.944 22.171 24 17.565 24 12.073z"/>
              </svg>
            </a>
          </div>
          <div className="footer-call">
            <p>Call Us Today</p>
            <a href="tel:+14694341574">+1 469-434-1574</a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container footer-bottom-inner">
          <p>Copyright Info: © 2025 Embrace Beauty. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
